import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { EPF } from 'src/model/epf.model';
import { CustomerService } from 'src/services/customer.service';
import { EpfService } from 'src/services/epf.service';

@Component({
    selector: 'app-update-customer',
    templateUrl: './update-customer.component.html',
    styleUrls: ['./update-customer.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class UpdateCustomerComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private epfService = inject(EpfService);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  protected datepipe = inject(DatePipe);
  private customerService = inject(CustomerService);

  @Input() customerToUpdate: Customer;
  updatingCustomer: Customer;

  @Input() epfDetails: EPF;
  updatingEPF: EPF;

  disableSubmit = false;
  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.updatingCustomer = Object.assign(new Customer(), this.customerToUpdate);

    if (this.epfDetails == undefined)
      this.epfDetails = new EPF();

    this.updatingEPF = Object.assign(new EPF(), this.epfDetails);
  }

  submit() {
    if (this.invalidFields())
      this.sharedService.openAlert('Please fill in all the fields correctly!', ALERT_TYPE.DANGER);
    else
      if (this.sharedService.isRoles([this.enums.BOSS, this.enums.BRANCH_MANAGER, this.enums.BOOKKEEPING_STAFF, this.enums.STAFF]))
        this.updateCustomer();
  }

  invalidFields() {
    const addressNull = (this.updatingCustomer.Address === '');
    if (this.sharedService.isStaff())
      return addressNull;
    else {
      const customerNameNull = (this.updatingCustomer.Name === '');
      const contactNoNull = (this.updatingCustomer.ContactNo === '');
      const icNumberInvalid = (this.updatingCustomer.ICNumber === '' || !this.sharedService.checkIfICValid(this.updatingCustomer.ICNumber));
      const raceNull = this.updatingCustomer.Race == undefined || this.updatingCustomer.Race == "";
      const genderNull = this.updatingCustomer.Gender == undefined || this.updatingCustomer.Gender == "";
      return (addressNull || customerNameNull || contactNoNull || icNumberInvalid || raceNull || genderNull)
    }
  }

  async updateCustomer() {
    this.disableSubmit = true;
    let customer: Customer;

    if (this.sharedService.isRoles([this.enums.BOSS, this.enums.BRANCH_MANAGER, this.enums.BOOKKEEPING_STAFF]))
      customer = this.updatingCustomer.toUpdate();
    else if (this.sharedService.isStaff())
      customer = this.updatingCustomer.toStaffUpdate();

    try {
      await this.customerService.putCustomer(this.customerToUpdate.ID, customer);
      this.sharedService.openAlert("Successfully updated customer", ALERT_TYPE.SUCCESS);
      this.passEntry.emit(true);
      this.reset();
    } finally {
      this.disableSubmit = false;
    }
  }

  confirmBeforeChangeDOB(): Promise<boolean> {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You are going to change DOB of custmomer, at the same time updating EPF DATE if necessary, are you sure?";
    return modalRef.result;
  }

  async updateDOB() {
    const confirm = await this.confirmBeforeChangeDOB();
    if (confirm) {
      if (this.customerToUpdate.DOB !== this.updatingCustomer.DOB || this.customerToUpdate.DOB == undefined) {
        const updatedCustomer = await this.customerService.updateCustomerDOB(this.customerToUpdate.ID, this.updatingCustomer.DOB);
        this.customerToUpdate.DOB = updatedCustomer.DOB;

        //only update epf details when successfully updated dob && epf date is not empty previously
        if (this.epfDetails.Date !== undefined) {
          this.updatingEPF.Date = this.sharedService.calculateEPFDate(this.updatingCustomer.DOB);
          await this.updateEPFDetails();
        } else
          this.sharedService.openAlert("Successfully updated customer dob", ALERT_TYPE.SUCCESS);
      } else {
        this.sharedService.openAlert("DOB is up to date!", ALERT_TYPE.DANGER)
      }
    }
  }

  onAmountPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const sanitized = pasted.replace(/,/g, '');
    this.updatingEPF.Amount = Number(sanitized);
  }

  async updateEPFDetails() {
    if ((this.epfDetails.Date === undefined || !this.sharedService.isSameDate(this.epfDetails.Date, this.updatingEPF.Date) || this.epfDetails.Amount === undefined || this.epfDetails.Amount !== this.updatingEPF.Amount)) {
      (this.epfDetails.Date === undefined && this.epfDetails.Amount === undefined) ? await this.epfService.postCustomerEPF(this.customerToUpdate.ID, this.updatingEPF) : await this.epfService.updateCustomerEPF(this.customerToUpdate.ID, this.updatingEPF);
      this.sharedService.openAlert("Successfully updated customer details", ALERT_TYPE.SUCCESS);
      this.passEntry.emit(true);
      this.reset();
    } else this.sharedService.openAlert("EPF DETAILS are up to date!", ALERT_TYPE.DANGER);
  }

  reset() {
    this.activeModal.close();
    this.updateCustomer = null;
  }
}
